import { Link, useNavigate } from "react-router-dom";
import { clearLead } from "@/lib/storage";

// Slim navy band header used on internal pages (dashboard / tools).
export const BrandHeader = ({ showSignOut = false }) => {
  const navigate = useNavigate();
  const signOut = () => {
    clearLead();
    navigate("/", { replace: true });
  };
  return (
    <header className="brand-navy-band" data-testid="brand-header">
      <div className="container-wide" style={{ padding: "0.9rem 1.25rem", display: "flex", alignItems: "center", justifyContent: "space-between", gap: "1rem" }}>
        <Link
          to="/dashboard"
          data-testid="brand-header-home-link"
          style={{ color: "var(--warm-white)", textDecoration: "none", display: "inline-flex", alignItems: "baseline", gap: "0.7rem", flexWrap: "wrap" }}
        >
          <span
            style={{
              fontFamily: '"Fraunces", Georgia, serif',
              fontWeight: 800,
              fontSize: 22,
              letterSpacing: "-0.01em",
              color: "var(--warm-white)",
              lineHeight: 1,
            }}
          >
            Legally<span style={{ color: "var(--yellow)" }}>Legit</span>.ai
          </span>
          <span
            aria-hidden="true"
            style={{
              display: "inline-block",
              width: 6, height: 6, background: "var(--yellow)",
              alignSelf: "center",
            }}
          />
          <span
            data-testid="brand-header-tag"
            style={{
              fontWeight: 700,
              letterSpacing: "0.1em",
              fontSize: 11,
              textTransform: "uppercase",
              color: "rgba(242, 233, 219, 0.85)",
            }}
          >
            Brand Protection Toolkit
          </span>
        </Link>
        <div style={{ display: "inline-flex", alignItems: "center", gap: "1.2rem" }}>
          <a
            href="https://indielaw.easywebinar.live/gettrademarked"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-webinar-link"
            style={{
              background: "var(--yellow)",
              color: "var(--navy)",
              textDecoration: "none",
              fontSize: 12.5,
              fontWeight: 800,
              letterSpacing: "0.06em",
              textTransform: "uppercase",
              padding: "0.55rem 0.9rem",
              borderRadius: 2,
              border: "2px solid var(--yellow)",
              display: "inline-flex",
              alignItems: "center",
              gap: "0.4rem",
              lineHeight: 1,
              transition: "transform 100ms ease, box-shadow 120ms ease, background-color 120ms ease",
              whiteSpace: "nowrap",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-1px)";
              e.currentTarget.style.boxShadow = "3px 3px 0 0 rgba(242,233,219,0.85)";
              e.currentTarget.style.background = "#ffdc33";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)";
              e.currentTarget.style.boxShadow = "none";
              e.currentTarget.style.background = "var(--yellow)";
            }}
          >
            <span style={{ display: "inline-block", width: 7, height: 7, borderRadius: "50%", background: "#b00020", marginRight: 2, animation: "pulse-dot 1.6s ease-in-out infinite" }} aria-hidden />
            Free Live Training · Enroll Now
          </a>
          {showSignOut && (
            <button
              type="button"
              onClick={signOut}
              data-testid="header-sign-out-button"
              style={{ background: "transparent", border: "none", color: "rgba(242,233,219,0.85)", fontSize: 12, cursor: "pointer", fontFamily: "Arial, sans-serif", letterSpacing: "0.04em", textTransform: "uppercase", padding: 0 }}
            >
              Sign out
            </button>
          )}
        </div>
      </div>
    </header>
  );
};
